const SHOP_TYPE_API_REQUEST="SHOP_TYPE/API_REQUEST";
const SHOP_TYPE_API_SUCCESS="SHOP_TYPE/API_SUCCESS";
const SHOP_TYPE_API_FAILED="SHOP_TYPE/API_FAILED";

export {SHOP_TYPE_API_REQUEST, SHOP_TYPE_API_SUCCESS, SHOP_TYPE_API_FAILED}